export enum PrivacyNoticeDataTest {
  PRIVACY_NOTICE_BLURB = "PRIVACY_NOTICE_BLURB",
  YES_BTN = "PRIVACY_YES_BTN",
  NO_BTN = "PRIVACY_NO_BTN",
  ALERT_CUSTOMER = "ALERT_CUSTOMER",
}
  